import React from "react";

class DropdownCondPag extends React.Component {
  render() {
    return (
      <React.Fragment>
        <option></option>
        <option value="0001">Pronto pagamento</option>
        <option value="0009">Pagamento em 4 Prestações iguais</option>
        <option value="0010">Pagamento a 15 dias</option>
        <option value="0002">Pagamento a 30 dias</option>
        <option value="0003">Pagamento a 45 dias</option>
        <option value="0008">Pagamento a 50 dias</option>
        <option value="0004">Pagamento a 60 dias</option>
        <option value="0005">Pagamento a 75 dias</option>
        <option value="0006">Pagamento a 90 dias</option>
        <option value="0007">Pagamento a 120 dias</option>
        <option value="0011">Pagamento Fatura/Recibo</option>
      </React.Fragment>
    );
  }
}

export default DropdownCondPag;
